import { render, staticRenderFns } from "./bankrw.vue?vue&type=template&id=410982d0&scoped=true"
import script from "./bankrw.vue?vue&type=script&lang=js"
export * from "./bankrw.vue?vue&type=script&lang=js"
import style0 from "./bankrw.vue?vue&type=style&index=0&id=410982d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410982d0",
  null
  
)

export default component.exports